module.exports = __webpack_public_path__ + "img/community.58b6d8e6.svg";